import {
  DebouncedDateInput,
  DebouncedTextInput,
  Group,
  GroupItem,
  GroupTitle,
} from "ra-friendsofbabba";

import { Input } from "../../component/input";
import React from "react";
import moment from "moment";

const isAdult =
  (message = "ra.validation.is_not_adult") =>
  (value) => {
    if (!value || value.length === 0) {
      return undefined;
    }
    const date = moment(value);
    if (!date.isValid()) {
      return undefined;
    }
    const today = moment();

    const years = today.get("year") - date.get("year");
    return years >= 18
      ? years >= 100
        ? message.replace("_not_", "_too_")
        : undefined
      : message;
  };
const UserProfileInput = ({ label, ...props }) => (
  <Group {...props} wrapper>
    <GroupTitle title={label} />
    <Group fullWidth>
      <GroupItem>
        <Input
          isRequired
          maxLength={50}
          source="user.profile.name"
          component={<DebouncedTextInput />}
        />
      </GroupItem>
      <GroupItem>
        <Input
          isRequired
          maxLength={50}
          source="user.profile.surname"
          component={<DebouncedTextInput />}
        />
      </GroupItem>
    </Group>
    <Group fullWidth>
      <GroupItem>
        <Input
          isRequired
          maxLength={50}
          source="user.profile.birth_place"
          component={<DebouncedTextInput />}
        />
      </GroupItem>
      <GroupItem>
        <Input
          isRequired
          maxLength={50}
          source="user.profile.birth_date"
          validate={isAdult()}
          component={<DebouncedDateInput />}
        />
      </GroupItem>
    </Group>
    <Group fullWidth>
      <GroupItem>
        <Input
          isRequired
          maxLength={50}
          source="user.email"
          component={<DebouncedTextInput />}
        />
      </GroupItem>
      <GroupItem>
        <Input
          isRequired
          maxLength={50}
          source="user.profile.phone"
          component={<DebouncedTextInput />}
        />
      </GroupItem>
    </Group>
  </Group>
);
export default UserProfileInput;
